import clsx from "clsx";
import React, { useState } from "react";
import { useLanguage } from "../../Contexts/LanguageContext";

import { Interface } from "./Interface";
import { useAudioguide } from "../../Hooks/useAudioguide";

import strings from "../../strings";

import * as styles from "./styles.module.scss";

export const Player = () => {
    const [open, setOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const { language: contextLanguage } = useLanguage();

    const {
        loading,
        error,
        guide,
        language,
        version,
        setLanguageCode,
        setVersionSlug,
    } = useAudioguide(
        contextLanguage,
        () => setOpen(true),
        () => setExpanded(true),
    );

    const closePlayer = () => {
        setOpen(false);
        setExpanded(false);
    }

    const stringsLanguageKey = contextLanguage === 'sv' ? 'sv' : 'en'; // default to en if language is not supported in strings

    return (
        <div
            className={clsx(styles.container, {
                [styles.open]: open,
                [styles.expanded]: expanded,
                [styles.compact]: !expanded,
                [styles.loaded]: !loading,
            })}
            data-audio-tracking-guide={guide?.title}
            data-audio-tracking-language={language?.name}
            data-audio-tracking-version={version?.name}
        >
            {loading ? (
                <div className={styles.initialContent}>
                    <span className={styles.initialContentLoader}></span>
                </div>
            ) : null}
            {error && !loading ? (
                <div className={styles.initialContent}>
                    <div className={styles.initialContentError}>
                        <p>{strings.AUDIOGUIDE_ERROR_TEXT[stringsLanguageKey]}</p>
                        <button 
                            className={styles.initialContentErrorButton} 
                            onClick={closePlayer}
                        >{strings.AUDIOGUIDE_ERROR_CLOSE_BUTTON[stringsLanguageKey]}</button>
                    </div>
                </div>
            ) : null}
            <div className={styles.content}>
                <Interface
                    guide={guide}
                    language={language}
                    version={version}
                    open={open}
                    loading={loading}
                    expanded={expanded}
                    setLanguage={setLanguageCode}
                    setVersion={setVersionSlug}
                    setExpanded={setExpanded}
                    setOpen={setOpen}
                />
            </div>
        </div>
    );
};
